import { useTranslation } from 'react-i18next'

export const usePayablesSummaryLabelsMap = () => {
    const { t } = useTranslation('translations')

    return {
        invoiceNo: t('payables_summary_table.invoiceNo'),
        providerName: t('payables_summary_table.providerName'),
        billDate: t('payables_summary_table.billDate'),
        dueDate: t('payables_summary_table.dueDate'),
        billsCount: t('payables_summary_table.billsCount'),
        totalInvoiced: t('payables_summary_table.totalInvoiced'),
        charges: t('payables_summary_table.charges'),
    }
}

export type PayablesSummaryLabelsMap = {
    invoiceNo: string
    providerName: string
    billDate: string
    dueDate: string
    billsCount: string
    totalInvoiced: string
    charges: string
}
